import * as React from 'react';
import { DragSource, DragSourceConnector, DragSourceMonitor } from 'react-dnd';

import { IBrochureProduct } from '../../../../../infrastructure/interfaces';
import { placeholderTypes } from '../../../../../infrastructure/placeholderTypes';
import { toggleDragginClass } from '../../../../../lib/helpers';

export interface IBrochureProductItemProps {
  product: IBrochureProduct;
  connectDragSource?(element: JSX.Element): JSX.Element;
  type: string;
  isDragging?: boolean;
  className: string;
}

class ProductItem extends React.Component<IBrochureProductItemProps> {

  constructor(props: any) {
    super(props);
  }

  render() {
    const className = `${this.props.className} ${this.props.isDragging ? "active" : ""}`;

    if (this.props.connectDragSource == undefined) {
      return(
        <li className={className} dangerouslySetInnerHTML={{
          __html: this.props.product.name
            .replace(/(®)/g, '<sup>®</sup>')
            .replace(/<sup><sup>/g, '<sup>')
            .replace(/<\/sup><\/sup>/g, '</sup>'),
        }}></li>
      );
    }

    const isDragging = (this.props.isDragging != undefined) ? this.props.isDragging : false;
    toggleDragginClass(isDragging);
    return this.props.connectDragSource(
      <li className={className} dangerouslySetInnerHTML={{
        __html: this.props.product.name.replace(/(®)/g, '<sup>®</sup>'),
      }}></li>,
    );
  }
}

const boxSource = {
  beginDrag(props: any) {
    return {
      data: props.product,
      type: placeholderTypes.Product,
    };
  },
};

function collectDrag(connect: DragSourceConnector, monitor: DragSourceMonitor) {
    return {
      connectDragSource: connect.dragSource(),
      isDragging: monitor.isDragging(),
    };
}

export default(
  DragSource(props => props.type, boxSource, collectDrag)
)(ProductItem);



// WEBPACK FOOTER //
// ./src/components/Editor/components/SidePanel/ProductTab/ProductItem.tsx